import { URL } from "../constants/url";
import axios from "axios";

export const postBill = (billData,responseStatus) => {
    axios
      .post(`${URL}/api/bills`, billData)
      .then((response) => {
        responseStatus(response.status); // Log response data
        // Set response data to state if needed
        // console.log("sucees"+ response.status)
      })
      .catch((error) => {
        responseStatus(error);
        console.log(error.message)
      });
  };